import { render, staticRenderFns } from "./TabsDashboardRequests.vue?vue&type=template&id=5538bbf0&"
import script from "./TabsDashboardRequests.vue?vue&type=script&lang=js&"
export * from "./TabsDashboardRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports